import React from 'react';
import { Typography, Box, Button } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import { TickSuccessIcon } from '../../../kit/icons/TickSuccessIcon';
import { FillVkIcon } from '../../../kit/icons/FillVkIcon';
import { FillYouTubeIcon } from '../../../kit/icons/FillYouTubeIcon';
import { FillTelegramIcon } from '../../../kit/icons/FillTelegramIcon';
import styles, { createWrapperPaddings } from './stylesEmbedd';

const subscribtion =
  'Хотим ещё больше дать вам пользы. Подпишитесь на наш канал и соцсети.';
const iconLinks = [
  {
    href: 'https://vk.com/elbrusbootcamp',
    IconComponent: FillVkIcon,
  },
  {
    href: 'https://t.me/elbrusbootcamp1',
    IconComponent: FillTelegramIcon,
  },
  {
    href: 'https://www.youtube.com/channel/UCaKZxz2d1KI-wN3l6fX7zdQ/featured',
    IconComponent: FillYouTubeIcon,
  },
];

function EmbeddModalForm({
  children,
  title,
  titleStyle,
  contentWrapperStyle,
  subtitle,
  message,
  sentContent: { title: sentTitle, message: sentMessage },
  isSent,
  isError = false,
}) {
  return (
    <>
      {!isSent ? (
        <Box
          sx={{
            ...styles.contentWrapper,
            ...contentWrapperStyle,
            ...createWrapperPaddings(!!subtitle),
          }}
        >
          <>
            {subtitle && (
              <Typography sx={styles.subtitle} variant="mobileP3Helper">
                {subtitle}
              </Typography>
            )}
            {title && (
              <Typography
                sx={{ ...styles.title, ...(titleStyle || {}) }}
                variant="mobileH3"
              >
                {Array.isArray(title) ? title[0] : title}
              </Typography>
            )}

            {message && (
              <Typography
                variant="desktopP2"
                color="kit.text.secondary"
                sx={styles.message}
              >
                {message}
              </Typography>
            )}

            <Box sx={styles.formWrapper}>{children}</Box>
            <Typography
              variant="desktopP3Helper"
              color="kit.text.secondary"
              sx={{ marginTop: '16px', textAlign: 'start' }}
            >
              Продолжая, вы принимаете условия{' '}
              <Link
                target="_blank"
                href="https://elbrusboot.camp/privacy-policy/"
                variant="kitSecondaryAccent"
                fontSize={'inherit !important'}
              >
                соглашения
              </Link>
            </Typography>
            {isError && (
              <Typography variant="mobileHelper" sx={styles.error}>
                Что-то пошло не так. Попробуйте позже
              </Typography>
            )}
          </>
        </Box>
      ) : (
        <Box sx={styles.contentWrapper}>
          <TickSuccessIcon
            sx={{ mt: 2, width: 56, height: 39, color: '#14C366' }}
          />
          <Typography
            sx={{
              ...styles.title,
              fontSize: 34,
              fontWeight: 400,
              textAlign: 'start',
              mt: 3,
            }}
            variant="mobileH3"
          >
            {sentTitle}
          </Typography>
          {sentMessage && (
            <Typography
              variant="desktopP2"
              sx={{
                ...styles.message,
                fontSize: { xs: 16, md: 18 },
                color: 'kit.text.main',
              }}
            >
              {sentMessage}
            </Typography>
          )}

          <Typography
            color="kit.text.main"
            variant="desktopP2"
            sx={styles.subscribe}
          >
            {subscribtion}
          </Typography>

          <Box sx={styles.social}>
            {iconLinks.map(({ href, IconComponent }) => (
              <Link
                key={href}
                href={href}
                variant="kitSecondaryInverse"
                target="_blank"
                sx={styles.iconLink}
              >
                <IconComponent sx={styles.icon} />
              </Link>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
}

export default EmbeddModalForm;
